import React, { useState, useEffect } from "react";
import "./LoanTable.scss";
import { TableCell, TableRow, Box, Button, TextField, TableHead, TableBody, Table, TableContainer, Grid, Pagination, CircularProgress  } from "@mui/material";
import { createLoanPayment, createLoanPaymentNew, getLoan } from "../../util/API/loandisk";
import { useSelector } from "react-redux";
import { styled } from '@mui/material/styles';
import { tableCellClasses } from '@mui/material/TableCell';
import { getLoanRepayments } from "../../util/API/loandisk";
import CustomAlert from "../UI/CustomAlert/CustomAlert";
import BaseDrawer from "../UI/BaseDrawer/BaseDrawer";
import { loanStatusIDs, loanProductIDs } from "../../util/utilfunctions/loandiskMappings";
import { roundInterestRate } from "../../util/utilfunctions/loandiskMappings";
import PinPad from "../PinPad/PinPad";

function LoanDetailModal({ open, handleClose, loanid, loanData }) {
  const [loanInfo, setLoanInfo] = useState(null);
  const [repayments, setRepayments] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState(0.0);
  const [loadingTable, setLoadingTable] = useState(true);
  const [tablePages, setTablePages] = useState(0);
  const [pageNumber, setPageNumber] = useState(0);
  const [showPaymentButtonText, setShowPaymentButtonText] = useState(true);
  const [alert, setAlert] = useState(
    {
      severity: '',
      show: false,
      message: '',
      header: ''
    }
  );
  const [showPinPad, setShowPinPad] = useState(false);

  const currentUser = useSelector((state) => state.usersList.selectedUser);
  let agent = JSON.parse(sessionStorage.getItem("user")).payload?.body;

  async function getLoanDiskLoanInfo() {
    if (!loanid) return;
    let response = await getLoan(currentUser.User.id, loanid);
    if (response.Status !== "1") {
      return;
    }
    let loanDetails = response.loandetails.response.Results;
    let repayments = response.repayments.response.Results.record;
    if (repayments && !Array.isArray(repayments)) {
      repayments = [repayments];
    }
    let totalRepaymentPages = Math.ceil(response.repayments.response.TotalResults / 6);
    setLoanInfo(loanDetails);
    setRepayments(repayments?.reverse());
    setLoadingTable(false);
    setTablePages(totalRepaymentPages);
  }

  useEffect(() => {
    setLoadingTable(true);
    getLoanDiskLoanInfo();
  }, [loanid]);

  async function makePayment(event, PIN) {
    console.log("loandata========", loanData);
    if (paymentAmount <= 0) return;
    setShowPaymentButtonText(false);
    let response;
    if(loanData) {
      let employerName;
      let extendedFields = currentUser.User.extendedfields;
      extendedFields = extendedFields.replaceAll(/&(amp;)*quot;/g, '"');
      extendedFields = JSON.parse(extendedFields);

      console.log("extendedFields========", extendedFields?.employername);
      if(loanData?.custom_field_13329 && loanData?.custom_field_13329 !== "") {
        employerName = loanData?.custom_field_13329;
      } else if(extendedFields) {
        employerName = extendedFields?.employername;
      } else {
        employerName = "";
      }

      response = await createLoanPaymentNew(currentUser.User.id, paymentAmount, loanid, PIN, agent['User'].id, employerName, loanData?.loan_application_id);
    } else {
      response = await createLoanPayment(currentUser.User.id, paymentAmount, loanid, PIN, agent['User'].id);
    }
    if (response.Status != 1) {
      let errors = response.payload.msg;
      let errorMessage = '';
      if (!Array.isArray(errors)) {
        errors = [errors];
      }
      for (let error of errors) {
        errorMessage += `${error}\n`;
      }
      setAlert(
        {
          header: 'Error',
          show: true,
          severity: 'error',
          message: errorMessage
        }
      )
      setShowPaymentButtonText(true);
      return;
    }
    setAlert(
      {
        header: 'Success',
        show: true,
        severity: 'success',
        message: 'Payment completed'
      }
    );
    await handlePageChange(pageNumber);
    await getLoanDiskLoanInfo();
    setShowPaymentButtonText(true);
  }

  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: 'rgba(0,0,0, .1)',
      color: theme.palette.common.black,
      fontWeight: 'bold'
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 25,
      fontWeight: '600'
    },
  }));

  const handlePageChange = async (page) => {
    setLoadingTable(true);
    setPageNumber(page);
    let response = await getLoanRepayments(loanid, page);
    let apiResponse = response.payload.body.response;
    let repaymentHistory = apiResponse.Results.record
    if (repaymentHistory && !Array.isArray(repayments)) {
      repaymentHistory = [repaymentHistory];
    }
    setRepayments(repaymentHistory);
    setTablePages(Math.ceil(apiResponse.TotalResults) / 6);
    setLoadingTable(false);
  }

  const handlePaymentAmountChange = (event) => {
    setPaymentAmount(event.target.value);
  };

  const StyledTextField = styled(TextField)(({ theme }) => ({
    width: '25%',
  }));

  const handleRecordLoanClick = () => {
    if (!paymentAmount || parseFloat(paymentAmount) <= 0) {
      setAlert(
        {
          header: 'Error!',
          show: true,
          severity: 'error',
          message: "Please enter a value greater than 0 to be recorded"
        }
      );
      // setAlert({
      //   showAlert: true,
      //   severity: "error",
      //   message: "Please enter a value greater than 0 to be recorded",
      //   header: "Error!"
      // });
      return;
    }
    setShowPinPad(true);
  };

  const handleConfirm = (event, pin) => {
    let PIN = pin.join('');
    makePayment(event, PIN);
    setShowPinPad(false);
  };

  return (
    <BaseDrawer
      open={open}
      handleClose={handleClose}
      height="80vh"
      title="Loan Details"
    >
      <Box sx={{ padding: '20px' }}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          {/* <Typography variant="h4">Loan Details</Typography> */}
        </Box>
        <Box>
          <div className="loaninfo-container">
            <div className="loaninfo-left">
              <div className="input-row">
                <StyledTextField
                  disabled
                  value={loanInfo?.loan_id}
                  label="Loan Request ID"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value="USD"
                  label="Loan Currency"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={loanInfo?.loan_principal_amount}
                  label="Principal Amount"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
              </div>
              <div className="input-row">
                <StyledTextField
                  disabled
                  value={loanInfo?.loan_application_id}
                  label="Reference Number"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={`${loanInfo?.loan_duration} ${loanInfo?.loan_duration_period}`}
                  label="Loan Duration"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={`${roundInterestRate(loanInfo?.loan_interest, loanInfo?.loan_decimal_places)}%`}
                  label="Interest Rate"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
              </div>
              <div className="input-row">
                <StyledTextField
                  disabled
                  value={loanProductIDs[loanInfo?.loan_product_id]}
                  label="Loan Type"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={loanStatusIDs[loanInfo?.loan_status_id]}
                  label="Loan Status"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={`${loanInfo?.loan_released_date}`}
                  label="Loan Released"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
              </div>
              <div className="input-row">
                <StyledTextField
                  disabled
                  value={loanInfo?.loan_duration_period}
                  label="Interest Period"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={`${loanInfo?.pending_due_penalty}`}
                  label="Interest Due"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={`${loanInfo?.pending_due_principal}`}
                  label="Amount Due"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
              </div>
              <div className="input-row">
                <StyledTextField
                  disabled
                  value={loanInfo?.balance_amount}
                  label="Balance Amount Due"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={loanInfo?.pending_due}
                  label="Next Pending Due"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
                <StyledTextField
                  disabled
                  value={loanInfo?.total_paid}
                  label="Total Amount Paid"
                  size="small"
                  InputLabelProps={{
                    shrink: true, // Ensures the label doesn't overlap
                  }}
                />
              </div>
            </div>

            <div className="loaninfo-right">
              <h3 className="text-center pt-3">Recent Transactions</h3>

              <TableContainer >
                <Table>
                  <TableHead>
                    <TableRow>
                      <StyledTableCell>Transaction ID</StyledTableCell>
                      <StyledTableCell>Date</StyledTableCell>
                      <StyledTableCell>Transaction Amount</StyledTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {loadingTable && (
                      <TableRow>
                        <TableCell colSpan={3}>
                          <Grid container justifyContent="center" alignItems="center">
                            <span className="loader" />
                          </Grid>
                        </TableCell>
                      </TableRow>
                    )}
                    {repayments && !loadingTable && repayments.map((row, index) => (
                      <TableRow key={row.repayment_id}>
                        <TableCell align="left" className="">
                          {row.repayment_id}
                        </TableCell>
                        <TableCell align="left" className="">
                          <div>
                            {row.loandisk_system_date}
                          </div>
                        </TableCell>
                        <TableCell align="right" className="">
                          <div>
                            ${row.repayment_amount}
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
              <Box sx={{ display: 'flex', justifyContent: 'flex-end', padding: 2 }}>
                  <Pagination
                    count={tablePages}
                    color="primary"
                    onChange={(event, page) => handlePageChange(page)}
                    showFirstButton 
                    showLastButton
                  />
                </Box>

              <div className="loan-payment-container">
                <Box sx={{ display: 'flex', gap: 2, justifyContent: 'flex-end' }}>
                  <TextField
                    required
                    id="loan-repayment-amount"
                    label="Payment Amount"
                    size="small"
                    placeholder="0.00"
                    onChange={handlePaymentAmountChange}
                  />
                  <Button
                    variant="contained"
                    // onClick={makePayment}
                    onClick={handleRecordLoanClick}
                    sx={{minWidth: 170}}
                    disabled = {!showPaymentButtonText}
                  >
                    { showPaymentButtonText ? 'Record Payment' : <CircularProgress size={24} />}
                  </Button>
                </Box>
              </div>
            </div>

          </div>
        </Box>
      </Box>
      <CustomAlert 
        severity={alert.severity} 
        show={alert.show} 
        header={alert.header} 
        message={alert.message} 
        onClick={(prevDetails) => setAlert({...prevDetails, showAlert: false})} 
        autoclose={alert.severity === "error" ? false : true} 
      />
      {showPinPad && 
        <PinPad 
          show={showPinPad} 
          handleConfirm={handleConfirm} 
          onClick={() => setShowPinPad(false)} 
        />
      }
    </BaseDrawer>

  );
}

export default LoanDetailModal;
